// extracted by mini-css-extract-plugin
module.exports = {"title":"SchedularData-module__title__2HFKw","data":"SchedularData-module__data__1zCZL"};